import { useState } from "react";
import { Button } from "../../../components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../components/ui/dialog";

import { Label } from "../../../components/ui/label";

import { Edit2Icon } from "lucide-react";
import { Input } from "../../../components/ui/input";

export function EditIndexOptionsModal({
  clientId,
  broker,
  prevMultiplier,
  prevBankNiftyMultiplier,
  prevFinNiftyMultiplier,
  prevMidcpNiftyMultiplier,
  prevSensexMultiplier,
  prevMcxMultiplier,
  handleEditIndexOptionsConfig,
}) {
  const [open, setOpen] = useState(false);
  const [indexMultiplier, setIndexMultiplier] = useState(prevMultiplier);
  const [bankNiftyMultiplier, setBankNiftyMultiplier] = useState(prevBankNiftyMultiplier);
  const [finNiftyMultiplier, setFinNiftyMultiplier] = useState(prevFinNiftyMultiplier);
  const [midcpNiftyMultiplier, setMidcpNiftyMultiplier] = useState(prevMidcpNiftyMultiplier);
  const [sensexMultiplier, setSensexMultiplier] = useState(prevSensexMultiplier);
  const [mcxMultiplier, setMcxMultiplier] = useState(prevMcxMultiplier);

  const handleEditIndexMultiplier = () => {
    const payload = {
      clientId: clientId,
      broker: broker,
      indexMultiplier: Number(indexMultiplier),
      bankniftyMultiplier: Number(bankNiftyMultiplier),
      finniftyMultiplier: Number(finNiftyMultiplier),
      midcpniftyMultiplier: Number(midcpNiftyMultiplier),
      sensexMultiplier: Number(sensexMultiplier),
      mcxMultiplier: Number(mcxMultiplier)
    };

    handleEditIndexOptionsConfig(clientId, payload);

    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button className="bg-zinc-800 text-white px-2.5 hover:bg-zinc-700  rounded-[5px]">
          <Edit2Icon className="w-4 h-4 " />
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[525px] border-zinc-700">
        <DialogHeader>
          <DialogTitle className="text-white">
            Edit Index Options Multiplier
          </DialogTitle>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-4 py-4">
          <div className="grid grid-cols-1 items-center gap-4">
            <Label className="text-white">Index Multiplier</Label>
            <Input
              type="number"
              placeholder="Enter Multiplier"
              className="text-white"
              value={indexMultiplier}
              onChange={(e) => setIndexMultiplier(e.target.value)}
            />
          </div>
          
          <div className="grid grid-cols-1 items-center gap-4">
            <Label className="text-white">Bank Nifty Multiplier</Label>
            <Input
              type="number"
              placeholder="Enter Bank Nifty Multiplier"
              className="text-white"
              value={bankNiftyMultiplier}
              onChange={(e) => setBankNiftyMultiplier(e.target.value)}
            />
          </div>

          <div className="grid grid-cols-1 items-center gap-4">
            <Label className="text-white">Fin Nifty Multiplier</Label>
            <Input
              type="number"
              placeholder="Enter Fin Nifty Multiplier"
              className="text-white"
              value={finNiftyMultiplier}
              onChange={(e) => setFinNiftyMultiplier(e.target.value)}
            />
          </div>

          <div className="grid grid-cols-1 items-center gap-4">
            <Label className="text-white">Midcap Nifty Multiplier</Label>
            <Input
              type="number"
              placeholder="Enter Midcap Nifty Multiplier"
              className="text-white"
              value={midcpNiftyMultiplier}
              onChange={(e) => setMidcpNiftyMultiplier(e.target.value)}
            />
          </div>

          <div className="grid grid-cols-1 items-center gap-4">
            <Label className="text-white">Sensex Multiplier</Label>
            <Input
              type="number"
              placeholder="Enter Sensex Multiplier"
              className="text-white"
              value={sensexMultiplier}
              onChange={(e) => setSensexMultiplier(e.target.value)}
            />
          </div>
          
          <div className="grid grid-cols-1 items-center gap-4">
            <Label className="text-white">MCX Multiplier</Label>
            <Input
              type="number"
              placeholder="Enter MCX Multiplier"
              className="text-white"
              value={mcxMultiplier}
              onChange={(e) => setMcxMultiplier(e.target.value)}
            />
          </div>
        </div>
        <DialogFooter>
          <Button
            type="submit"
            className="text-[16px] font-normal bg-zinc-800 text-white hover:bg-zinc-700"
            onClick={handleEditIndexMultiplier}
          >
            Update Multiplier
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}